<template>
  <div id="app">
    <router-view />
    <el-dialog
      :visible.sync="showDia"
      width="25%"
      v-if="true"
      :custom-class="'leavePop'"
    >
      <h2 class="t18">确定离开吗？</h2>
      <div class="t14">您尚有未编辑的内容，请输入后保存后再离开当前页面</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="confirmYes" class="confirm-yes" type="danger"
          >确 定</el-button
        >
        <el-button @click="confirmNo" class="confirm-no">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      showDia: false,
    };
  },
  watch: {
    "$store.state.showLeave": {
      handler: function (newVal, oldVal) {
        this.showDia = newVal ? true : false;
      },
    },
    showDia(val) {
      !val && this.confirmNo();
    },
  },
  methods: {
    confirmYes() {
      let obj = this.$store.state.tabTemp;
      this.$store.dispatch("setTabTemp", {});
      this.$store.dispatch("setCommitFlag", false);
      this.$store.dispatch("setLeaveConfirm", true);
      setTimeout(() => {
        this.$store.dispatch("setLeaveConfirm", false);
      }, 300);
      this.$store.dispatch("addHeadTab", obj);
    },
    confirmNo() {
      this.$store.dispatch("setShowLeave", false);
    },
  },
};
</script>

<style lang='less'>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* margin-top: 60px; */
}
body {
  margin: 0;
  height: 100vh;
  overflow: hidden;
}
/* 全局弹框提示 */

.el-message,
.el-message.user-info {
  display: block !important;
  height: auto;
  padding: 37px 18px 20px 18px !important;
  min-height: 155px;
  min-width: 176px !important;
  /* width: 176px; */
  background: rgba(8, 18, 52, 0.6) !important;
  border-radius: 4px;
  text-align: center;
  border: none;
  z-index: 3010 !important;
}
.el-message i.el-message__icon,
.el-message.user-info i {
  position: relative;
  display: block;
  margin: 0 auto;
  width: 42px;
  height: 42px;
  background-color: #ffffff;
  border-radius: 100%;
  margin-bottom: 16px;
}
.el-message i.el-message__icon::before,
.el-message.user-info i::before {
  position: absolute;
  left: -7px;
  top: -4px;
  display: block;
  width: 54px;
  height: 54px;
  font-size: 54px;
}
.el-message p.el-message__content,
.el-message.user-info p.el-message__content {
  display: block;
  min-width: 140px;
  max-width: 200px;
  height: auto;
  font-size: 16px;
  font-family: MicrosoftYaHei;
  color: rgba(255, 255, 255, 1);
  line-height: 21px;
  text-align: center;
  /* word-wrap: none;
  word-break: keep-all; */
}
.el-message .el-icon-error {
  color: #ff6529;
}
.el-message .el-icon-success {
  color: #42d045;
}
.el-message.user-info .icon-yk_gantanhao_fill {
  color: #2e71fe;
}
.el-dialog__footer {
  padding: 0 0 40px 0;
  text-align: center;
  .el-button {
    width: 130px;
    height: 42px;
  }
  .confirm-yes {
    background-color: @SAASCOLOR;
  }
  .confirm-no {
    margin-left: 18px;
    border-color: inherit;
    color: inherit;
    &:hover {
      color: inherit;
      background-color: inherit;
      border-color: inherit;
    }
  }
}
.el-dialog.leavePop {
  color: @SAASFONTCOLOR;
  border-radius: 10px;
  /deep/ .el-dialog__header {
    display: none;
  }
  /deep/ .el-dialog__body {
    padding: 40px;
    text-align: left;
  }
  div .el-button--default.el-button:hover {
    border-color: inherit;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue